'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var utils = require('../utils.js');
var Stepper_module = require('./Stepper.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Stepper = ({
  activeStep,
  partialFill = false,
  partialWidth = '30%',
  exception = false,
  icons,
  stepperColor
}) => {
  const getWidth = index => {
    if (index === activeStep + 1) {
      return partialFill ? partialWidth : '0';
    }
    return index <= activeStep ? '100%' : '0';
  };
  const getIcon = index => {
    if (exception) {
      return icons.error[index];
    }
    if (index <= activeStep) {
      return icons.activeIcons[index];
    }
    return icons.inactiveIcons[index] ?? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: Stepper_module["default"].container
  }, Array.from(Array(exception ? icons.error.length : icons.activeIcons.length).keys()).map(index => /*#__PURE__*/React__default["default"].createElement("div", {
    key: index,
    className: Stepper_module["default"].stepContainer,
    style: {
      width: index === 0 ? 'auto' : '100%'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Stepper_module["default"].icon
  }, getIcon(index)), index !== 0 && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Stepper_module["default"].progressContainer,
    style: {
      justifyContent: exception ? 'center' : 'start',
      backgroundColor: utils.addAlpha(stepperColor, 0.2)
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: Stepper_module["default"].filledProgress,
    style: {
      width: getWidth(index),
      borderColor: stepperColor
    }
  })))));
};

exports["default"] = Stepper;
